module.exports = __webpack_public_path__ + "static/media/cloud2.2870636a.svg";